import { initContract } from '@ts-rest/core'
import { ErrorResponseSchema } from '../../shared/types'
import { PauseReasonSchema } from './pauseReason.schemas'

const c = initContract()

const options = {
  pathPrefix: '/pause-reasons',
  commonResponses: {
    400: ErrorResponseSchema,
    500: ErrorResponseSchema,
    404: ErrorResponseSchema,
  },
}

export const pauseReasonServiceContract = c.router({
  getPauseReasons: {
    method: 'GET',
    path: '',
    responses: {
      200: PauseReasonSchema.array(),
    },
  },
}, options)
